export default [
  {
    path: '/admin/defines/interview-statuses',
    name: 'InterviewStatuses',
    component: () => import('@/views/Admin/Defines/Interview_statuses/Index.vue'),
    meta: {
      pageTitle: 'Görüşme Durumları',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/interview-statuses/add',
    name: 'InterviewStatusAdd',
    component: () => import('@/views/Admin/Defines/Interview_statuses/Add.vue'),
    meta: {
      pageTitle: 'Görüşme Durumları',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/interview-statuses',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/interview-statuses/edit/:id',
    name: 'InterviewStatusEdit',
    component: () => import('@/views/Admin/Defines/Interview_statuses/Edit.vue'),
    meta: {
      pageTitle: 'Görüşme Durumları',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/interview-statuses',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
]
